import React from "react";
import { motion } from "framer-motion";
import { Box, Card, CardMedia, Container, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { brand, categories } from "../data/estoreContent";
import { estoreShopUrl } from "../data/estorePaths";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.07, delayChildren: 0.05 },
  },
};

const item = {
  hidden: { opacity: 0, y: 22 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] } },
};

function EstoreCategories() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 5, md: 7 } }}>
      <motion.div initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.5 }}>
        <Typography variant="overline" sx={{ color: brand.muted, letterSpacing: "0.2em", fontWeight: 700 }}>
          Browse
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 800, color: brand.text, mb: 3, letterSpacing: "-0.02em" }}>
          Categories
        </Typography>
      </motion.div>

      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-40px" }}>
        <Grid container spacing={2.5}>
          {categories.map((cat) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={cat.name}>
              <motion.div variants={item} whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 320, damping: 22 }}>
                <Card
                  elevation={0}
                  onClick={() => navigate(estoreShopUrl(cat.name))}
                  sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    cursor: "pointer",
                    border: `1px solid ${brand.stroke}`,
                    bgcolor: "#fff",
                  }}
                >
                  <Box sx={{ position: "relative", height: 200, overflow: "hidden" }}>
                    <CardMedia
                      component="img"
                      height="200"
                      image={cat.image}
                      alt={cat.name}
                      sx={{
                        transition: "transform 0.55s cubic-bezier(0.22, 1, 0.36, 1)",
                        "&:hover": { transform: "scale(1.06)" },
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        inset: 0,
                        background: "linear-gradient(180deg, transparent 20%, rgba(15,23,42,0.82) 100%)",
                      }}
                    />
                    <Box sx={{ position: "absolute", left: 16, bottom: 14, right: 16 }}>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: "#fff" }}>
                        {cat.name}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.82)" }}>
                        {cat.hint}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </Container>
  );
}

export default EstoreCategories;
